import { MapTo } from '@adobe/aem-react-editable-components';
import Topics, { TopicsEditConfig } from './Topics';

export default MapTo('cob-corp-acquisition/components/creditonebank/topics')(Topics, TopicsEditConfig);